<script setup lang="ts">
// types
import type { SectionQuoteProps } from '@ts-sections/section-quote/interfaces'
// hooks
import { useSectionQuote } from '@hooks/sections/section-quote.hook'
// components
import { SectionLayout } from '@UI/Layouts/SectionLayout'
import BlockQuote from '@Blocks/BlockQuote.vue'

defineOptions({
  name: 'SectionQuote',
})

const props = defineProps<{
  section: SectionQuoteProps
}>()

const {
  refTitle,
  refDescription,
  refBackgroundColor,
  refView,
  refQuotes,
} = useSectionQuote({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-quote"
    :data-component="section.__component"
    :title="refTitle"
    :title-tag="section.layout?.titleTag"
    :description="refDescription"
    :color="refBackgroundColor"
    :space="section.layout?.space"
  >
    <BlockQuote
      v-if="refView === 'one' && refQuotes[0]"
      :block="refQuotes[0]"
      surface="brand"
    />
    <ul
      v-else-if="refQuotes.length"
      class="section-quote__list"
    >
      <li
        v-for="(quote, index) in refQuotes"
        :key="quote.id ?? index"
      >
        <BlockQuote
          :block="quote"
          surface="tertiary"
        />
      </li>
    </ul>
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionQuote.scss" />
